import { useCallback, useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import {
  BOGO_EXPLAINER_MODAL_SHOULD_BE_SHOWN,
  DISCOUNT_MODAL_SHOULD_BE_SHOWN,
  PROMO_EXPLAINER_MODAL_SHOULD_BE_SHOWN,
} from '@mc/constants'

export const useModalOverride = () => {
  const [overridden, setOverridden] = useState(false)
  const [pathname, setPathname] = useState<string | undefined>()
  const router = useRouter()
  const validatorTimerRef = useRef<ReturnType<typeof setInterval>>()
  const cleanupTimerRef = useRef<ReturnType<typeof setTimeout>>()

  const validate = useCallback(() => {
    if (overridden && pathname === router.asPath) {
      return
    }

    const shouldOverride =
      window.sessionStorage.getItem(DISCOUNT_MODAL_SHOULD_BE_SHOWN) ===
        'true' ||
      window.sessionStorage.getItem(PROMO_EXPLAINER_MODAL_SHOULD_BE_SHOWN) ===
        'true' ||
      window.sessionStorage.getItem(BOGO_EXPLAINER_MODAL_SHOULD_BE_SHOWN) ===
        'true'

    if (shouldOverride) {
      setOverridden(true)
      setPathname(router.asPath)
      if (validatorTimerRef.current) clearInterval(validatorTimerRef.current)
    }
  }, [overridden, pathname, router.asPath])

  useEffect(() => {
    validatorTimerRef.current = setInterval(validate, 1000) // validate every second

    cleanupTimerRef.current = setTimeout(() => {
      // clean if after 10 seconds it's not overridden
      if (validatorTimerRef.current) clearInterval(validatorTimerRef.current)
    }, 10000) // 10 seconds

    return () => {
      if (validatorTimerRef.current) clearInterval(validatorTimerRef.current)
      if (cleanupTimerRef.current) clearTimeout(cleanupTimerRef.current)
    }
  }, [validate])

  useEffect(() => {
    validate()
  }, [router.asPath, validate])

  return { overridden }
}
